module.exports = __webpack_public_path__ + "img/logo_white.bf27dea7.png";